/* Zabi Hair — Navigatie: desktop mega-menu hover + mobiel drawer */
(function () {
  'use strict';

  function initHeader(header) {
    if (header.dataset.megaInit) return;
    header.dataset.megaInit = '1';

    /* ---------- Desktop mega-menu ---------- */
    var triggers = header.querySelectorAll('[data-mega-trigger]');
    var panels = header.querySelectorAll('[data-mega-panel]');
    var closeTimer = null;

    function panelFor(i) {
      return header.querySelector('[data-mega-panel="' + i + '"]');
    }
    function triggerFor(i) {
      return header.querySelector('[data-mega-trigger="' + i + '"]');
    }
    function closeAll() {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      triggers.forEach(function (t) {
        t.classList.remove('is-open');
        var link = t.querySelector('.zabi-header__menu-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }
    function open(i) {
      window.clearTimeout(closeTimer);
      var panel = panelFor(i);
      var trig = triggerFor(i);
      if (!panel || !trig) return;
      panels.forEach(function (p) { if (p !== panel) p.classList.remove('is-open'); });
      triggers.forEach(function (t) {
        if (t !== trig) {
          t.classList.remove('is-open');
          var l = t.querySelector('.zabi-header__menu-link');
          if (l) l.setAttribute('aria-expanded', 'false');
        }
      });
      panel.classList.add('is-open');
      trig.classList.add('is-open');
      var link = trig.querySelector('.zabi-header__menu-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }
    function scheduleClose() {
      window.clearTimeout(closeTimer);
      /* ruime close-delay zodat een korte pauze tijdens het bewegen van
         trigger naar paneel de dropdown niet direct sluit */
      closeTimer = window.setTimeout(closeAll, 320);
    }

    triggers.forEach(function (trig) {
      var i = trig.getAttribute('data-mega-trigger');
      trig.addEventListener('mouseenter', function () { open(i); });
      trig.addEventListener('mouseleave', scheduleClose);
      trig.addEventListener('focusin', function () { open(i); });
      trig.addEventListener('focusout', function (e) {
        if (!trig.contains(e.relatedTarget)) scheduleClose();
      });
    });
    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);
    });

    /* Klik buiten de header sluit een open mega-paneel */
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });

    /* ---------- Taal-switcher (native localisatie) — desktop + mobiel drawer ----------
       Drawer staat buiten <header>, dus document-scope + init-guard. */
    document.querySelectorAll('[data-lang-switch]').forEach(function (langSwitch) {
      if (langSwitch.dataset.langInit) return;
      langSwitch.dataset.langInit = '1';
      var langToggle = langSwitch.querySelector('[data-lang-toggle]');
      function closeLang() {
        langSwitch.classList.remove('is-open');
        if (langToggle) langToggle.setAttribute('aria-expanded', 'false');
      }
      function toggleLang() {
        var willOpen = !langSwitch.classList.contains('is-open');
        langSwitch.classList.toggle('is-open', willOpen);
        if (langToggle) langToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }
      if (langToggle) {
        langToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleLang();
        });
      }
      document.addEventListener('click', function (e) {
        if (!langSwitch.contains(e.target)) closeLang();
      });
      langSwitch.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeLang(); if (langToggle) langToggle.focus(); }
      });
    });

    /* ---------- Mobiel drawer ---------- */
    var menu = document.getElementById('ZabiMenu-' + (header.dataset.sectionId || ''));
    if (!menu) menu = header.parentNode.querySelector('.zabi-menu');
    var hamburger = header.querySelector('.zabi-header__hamburger');

    function openMenu() {
      if (!menu) return;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeMenu() {
      if (!menu) return;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    if (hamburger) hamburger.addEventListener('click', openMenu);
    if (menu) {
      menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
        el.addEventListener('click', closeMenu);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
        if (menu && menu.classList.contains('is-open')) closeMenu();
      }
    });
  }

  function init() {
    document.querySelectorAll('.zabi-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Shopify theme editor: her-init na section load
  document.addEventListener('shopify:section:load', init);
})();
